






















































































import {Component} from 'vue-property-decorator';
import {Getter} from "vuex-class";
import {ScrollButton} from "wings-ui-components";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import { BlacklistItem } from '@/store/blacklists/types'
import {DateTime} from "luxon";
import BlackListsFilter from "@/components/BlackLists/BlackListsFilter.vue";

@Component({components: {BlackListsFilter, ScrollButton},filters: {
  date(value: string) {
    if (!value) return;
    return DateTime.fromISO(value).toFormat('dd.LL.yyyy HH:mm:ss')
  }
}})
export default class BlackLists extends BaseItemsPage<BlacklistItem>{
  @Getter("blacklists") blacklistsResponse: any;
  private is_show_filter = false;
  currentSort = "name";
  currentSortOrder = "desc";
  tableFields = ['id', 'name', 'create_date', 'contacts', 'comment'];

  getData(): any {
    return this.blacklistsResponse;
  }
}
